import { Grid, Typography, Stack } from "@mui/material";

import SingleDropDown from "components/Dropdowns/SingleDropDown/SingleDropDown";
import TitleDefinition from "components/TitleDefinition";
import { CreateUpdateReductionMeasuresDesignProps } from "./data/CreateUpdateReductionMeasuresDesignProps";
import { TitleDefinitionConstants } from "constants/constant";

export default function MeasureMCA(
  props: Readonly<CreateUpdateReductionMeasuresDesignProps>
) {
  return (
    <Grid>
      <Typography
        variant="h6"
        data-testid={"measureReduction"}
        sx={{ fontWeight: 600, fontSize: 12, mb: 2 }}
      >
        Measure Multi-Criteria Assessment (MCA)
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={6} sx={{ mt: 1 }}>
          <Stack direction={"row"}>
            <Typography
              variant="body1"
              data-testid={"easeLabel"}
              sx={{ mb: 2, fontWeight: 600, fontSize: 12 }}
            >
              Ease
            </Typography>
            <TitleDefinition
              content={TitleDefinitionConstants.ReductionMeasure.easeRating}
              placement="auto"
            />
          </Stack>
          <SingleDropDown
            onChange={props.fieldChangeHandler}
            list={props.implementationComplexityList}
            value={
              props.draftReductionMeasure.easeRating === undefined
                ? ""
                : props.draftReductionMeasure.easeRating?.toString()
            }
            name={"easeRating"}
            sx={{ fontSize: 12, height: 30, minHeight: 30, boxSizing: 'border-box', '.MuiSelect-select': { display: 'flex', alignItems: 'center', height: 30, paddingTop: '4px', paddingBottom: '4px', fontSize: 12, boxSizing: 'border-box' } }}
          />
        </Grid>
        <Grid item xs={6} sx={{ mt: 1 }}>
          <Stack direction={"row"}>
            <Typography
              variant="body1"
              data-testid={"reputationLabel"}
              sx={{ mb: 2, fontWeight: 600, fontSize: 12 }}
            >
              Reputation
            </Typography>
            <TitleDefinition
              content={
                TitleDefinitionConstants.ReductionMeasure.reputationRating
              }
              placement="auto"
            />
          </Stack>
          <SingleDropDown
            onChange={props.fieldChangeHandler}
            list={props.reputationList}
            value={
              props.draftReductionMeasure.reputationRating === undefined
                ? ""
                : props.draftReductionMeasure.reputationRating?.toString()
            }
            name={"reputationRating"}
            sx={{ fontSize: 12, height: 30, minHeight: 30, boxSizing: 'border-box', '.MuiSelect-select': { display: 'flex', alignItems: 'center', height: 30, paddingTop: '4px', paddingBottom: '4px', fontSize: 12, boxSizing: 'border-box' } }}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={6} sx={{ mt: 1 }}>
          <Stack direction={"row"}>
            <Typography
              variant="body1"
              data-testid={"climateRiskLabel"}
              sx={{ mb: 2, fontWeight: 600, fontSize: 12 }}
            >
              Climate Risk
            </Typography>
            <TitleDefinition
              content={
                TitleDefinitionConstants.ReductionMeasure.climateRiskRating
              }
              placement="auto"
            />
          </Stack>
          <SingleDropDown
            onChange={props.fieldChangeHandler}
            list={props.climateRiskList}
            value={
              props.draftReductionMeasure.climateRiskRating === undefined
                ? ""
                : props.draftReductionMeasure.climateRiskRating?.toString()
            }
            name={"climateRiskRating"}
            sx={{ fontSize: 12, height: 30, minHeight: 30, boxSizing: 'border-box', '.MuiSelect-select': { display: 'flex', alignItems: 'center', height: 30, paddingTop: '4px', paddingBottom: '4px', fontSize: 12, boxSizing: 'border-box' } }}
          />
        </Grid>
        <Grid item xs={6} sx={{ mt: 1 }}>
          <Stack direction={"row"}>
            <Typography
              variant="body1"
              data-testid={"biodiversityLabel"}
              sx={{ mb: 2, fontWeight: 600, fontSize: 12 }}
            >
              Biodiversity
            </Typography>
            <TitleDefinition
              content={
                TitleDefinitionConstants.ReductionMeasure.biodiversityRating
              }
              placement="auto"
            />
          </Stack>
          <SingleDropDown
            onChange={props.fieldChangeHandler}
            list={props.biodiversityList}
            value={
              props.draftReductionMeasure.biodiversityRating === undefined
                ? ""
                : props.draftReductionMeasure.biodiversityRating?.toString()
            }
            name={"biodiversityRating"}
            sx={{ fontSize: 12, height: 30, minHeight: 30, boxSizing: 'border-box', '.MuiSelect-select': { display: 'flex', alignItems: 'center', height: 30, paddingTop: '4px', paddingBottom: '4px', fontSize: 12, boxSizing: 'border-box' } }}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={6} sx={{ mt: 1 }}>
          <Stack direction={"row"}>
            <Typography
              variant="body1"
              data-testid={"communityLabel"}
              sx={{ mb: 2, fontWeight: 600, fontSize: 12 }}
            >
              Community
            </Typography>
            <TitleDefinition
              content={
                TitleDefinitionConstants.ReductionMeasure.communityRating
              }
              placement="auto"
            />
          </Stack>
          <SingleDropDown
            onChange={props.fieldChangeHandler}
            list={props.communityList}
            value={
              props.draftReductionMeasure.communityRating === undefined
                ? ""
                : props.draftReductionMeasure.communityRating?.toString()
            }
            name={"communityRating"}
            sx={{ fontSize: 12, height: 30, minHeight: 30, boxSizing: 'border-box', '.MuiSelect-select': { display: 'flex', alignItems: 'center', height: 30, paddingTop: '4px', paddingBottom: '4px', fontSize: 12, boxSizing: 'border-box' } }}
          />
        </Grid>
        <Grid item xs={6} sx={{ mt: 1 }}>
          <Stack direction={"row"}>
            <Typography
              variant="body1"
              data-testid={"techReadinessLabel"}
              sx={{ mb: 2, fontWeight: 600, fontSize: 12 }}
            >
              Technology Readiness
            </Typography>
            <TitleDefinition
              content={
                TitleDefinitionConstants.ReductionMeasure
                  .technologyRedinessRating
              }
              placement="auto"
            />
          </Stack>
          <SingleDropDown
            onChange={props.fieldChangeHandler}
            list={props.techReadinessList}
            value={
              props.draftReductionMeasure.technologyRedinessRating === undefined
                ? ""
                : props.draftReductionMeasure.technologyRedinessRating?.toString()
            }
            name={"technologyRedinessRating"}
            sx={{ fontSize: 12, height: 30, minHeight: 30, boxSizing: 'border-box', '.MuiSelect-select': { display: 'flex', alignItems: 'center', height: 30, paddingTop: '4px', paddingBottom: '4px', fontSize: 12, boxSizing: 'border-box' } }}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={6} sx={{ mt: 1 }}>
          <Stack direction={"row"}>
            <Typography
              variant="body1"
              data-testid={"OpDisruptionLabel"}
              sx={{ mb: 2, fontWeight: 600, fontSize: 12 }}
            >
              Operational Disruption
            </Typography>
            <TitleDefinition
              content={
                TitleDefinitionConstants.ReductionMeasure
                  .operationalDisruptionRating
              }
              placement="auto"
            />
          </Stack>
          <SingleDropDown
            onChange={props.fieldChangeHandler}
            list={props.opDisruptionList}
            value={
              props.draftReductionMeasure.operationalDisruptionRating ===
              undefined
                ? ""
                : props.draftReductionMeasure.operationalDisruptionRating?.toString()
            }
            name={"operationalDisruptionRating"}
            sx={{ fontSize: 12, height: 30, minHeight: 30, boxSizing: 'border-box', '.MuiSelect-select': { display: 'flex', alignItems: 'center', height: 30, paddingTop: '4px', paddingBottom: '4px', fontSize: 12, boxSizing: 'border-box' } }}
          />
        </Grid>
        <Grid item xs={6} sx={{ mt: 1 }}>
          <Stack direction={"row"}>
            <Typography
              variant="body1"
              data-testid={"HealthSafetyRatingLabel"}
              sx={{ mb: 2, fontWeight: 600, fontSize: 12 }}
            >
              Health & Safety
            </Typography>
            <TitleDefinition
              content={
                TitleDefinitionConstants.ReductionMeasure.healthSafetyRating
              }
              placement="auto"
            />
          </Stack>
          <SingleDropDown
            onChange={props.fieldChangeHandler}
            list={props.healthSafetyList}
            value={
              props.draftReductionMeasure.healthSafetyRating === undefined
                ? ""
                : props.draftReductionMeasure.healthSafetyRating?.toString()
            }
            name={"healthSafetyRating"}
            sx={{ fontSize: 12, height: 30, minHeight: 30, boxSizing: 'border-box', '.MuiSelect-select': { display: 'flex', alignItems: 'center', height: 30, paddingTop: '4px', paddingBottom: '4px', fontSize: 12, boxSizing: 'border-box' } }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}
